import { uz } from './uz';
import { ru } from './ru';

export type Locale = 'uz' | 'ru';
export type TranslationKey = keyof typeof uz;

const translations: Record<Locale, Record<string, string>> = { uz, ru };

let currentLocale: Locale = (localStorage.getItem('safaro_admin_locale') as Locale) || 'uz';

export const getLocale = (): Locale => currentLocale;

export const setLocale = (locale: Locale) => {
  currentLocale = locale;
  localStorage.setItem('safaro_admin_locale', locale);
};

export const t = (key: string): string => {
  return translations[currentLocale]?.[key] || translations['uz']?.[key] || key;
};

export { uz, ru };
